import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";

export default function MenuComponent(props) {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const { setIsDiscardTaskModalOpen, planStatus, item, headerHeight } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = () => {
    setAnchorEl(null);
    setIsDiscardTaskModalOpen(true);
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-haspopup="true"
        onClick={handleClick}
        aria-controls="long-menu"
        style={{ padding: 0, color: "#dadada" }}
      >
        <MoreVertIcon />
      </IconButton>
      {planStatus.toLowerCase() === "verify" && (
        <Menu
          id="menu"
          keepMounted
          anchorEl={anchorEl}
          onClose={handleClose}
          open={Boolean(anchorEl)}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: headerHeight - headerHeight / 3.1,
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          MenuListProps={{
            style: {
              padding: 0,
            },
          }}
          PaperProps={{
            style: {
              borderRadius: "5px",
            },
          }}
        >
          {item.map((item, i) => {
            return (
              <MenuItem
                key={i}
                style={{
                  color: "#303B4A",
                  fontSize: "13px",
                }}
                onClick={() => handleAction()}
              >
                {item.label}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </div>
  );
}
